module.exports = __webpack_public_path__ + "static/media/technology-academic-performance.72e0dcd1.png";